import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    // Auto-close mobile menu when screen gets larger than 767px
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setIsOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <nav className="fixed top-0 w-full bg-black/90 backdrop-blur-sm z-50 border-b border-gray-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="text-xl font-bold text-white mywork">
                        Christopher Peacock | Television Editor
                    </div>

                    {/* Desktop menu */}
                    <div className="hidden md:flex space-x-8">
                        <a href="#home" className="text-white hover:text-blue-400 transition-colors mywork">Home</a>
                        <a href="#work" className="text-white hover:text-blue-400 transition-colors mywork">Work</a>
                        <a href="#credits" className="text-white hover:text-blue-400 transition-colors mywork">Credits</a>
                        <a href="#about" className="text-white hover:text-blue-400 transition-colors mywork">Bio</a>
                        <a href="#contact" className="text-white hover:text-blue-400 transition-colors mywork">Contact</a>
                    </div>

                    {/* Mobile menu button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="text-white focus:outline-none"
                        >
                            {isOpen ? <X size={24} /> : <Menu size={24} />}
                        </button>
                    </div>
                </div>

                {/* Mobile menu */}
                {isOpen && (
                    <div className="md:hidden mt-2 flex flex-col space-y-2 pb-4">
                        <a href="#home" onClick={() => setIsOpen(false)} className="text-white hover:text-blue-400 transition-colors">Home</a>
                        <a href="#work" onClick={() => setIsOpen(false)} className="text-white hover:text-blue-400 transition-colors">Work</a>
                        <a href="#credits" onClick={() => setIsOpen(false)} className="text-white hover:text-blue-400 transition-colors">Credits</a>
                        <a href="#about" onClick={() => setIsOpen(false)} className="text-white hover:text-blue-400 transition-colors">Bio</a>
                        <a href="#contact" onClick={() => setIsOpen(false)} className="text-white hover:text-blue-400 transition-colors">Contact</a>
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Navbar;
